import AdForm from './AdForm.vue';
import AdOfferList from './AdOfferList.vue';
import AdSearch from './AdSearch.vue';
import AdDetail from './AdDetail.vue';
import AdCompare from './AdCompare.vue';
import AdStatistics from './AdStatistics.vue';
import AdFilterList from './AdFilterList.vue';
import AdFormCompetition from './AdFormCompetition.vue';
import AdThankYou from './AdThankYou.vue';
import AdDeveloperProjectForm from './AdDeveloperProjectForm.vue';
import AdDeveloperProjectDetail from './AdDeveloperProjectDetail.vue';
import { OfferListMode } from './models/OfferListMode';
import EstateAgentPublicProfile from '@/estate-agent/EstateAgentPublicProfile.vue';
import EstateAgencyPublicProfile from '@/estate-agency/EstateAgencyPublicProfile.vue';

const adRoutes = [
  {
    path: '/ad/create',
    name: 'AdFormCreate',
    component: AdForm,
  },
  {
    path: '/ad/competition',
    name: 'AdFormCreateCompetition',
    component: AdFormCompetition,
    meta: {
      showHeader: false,
    },
  },
  {
    path: '/ad/:adFrontId',
    name: 'AdFormEdit',
    meta: { requiresAuth: true },
    component: AdForm,
    props: (route: any) => {
      return {
        adFrontId: route.params.adFrontId,
        afterInsert: Boolean(route.params.afterInsert),
      };
    },
  },
  {
    path: '/detail/:adFrontId',
    name: 'AdDetail',
    component: AdDetail,
    props: true,
  },
  {
    path: '/preview/:adFrontId',
    name: 'AdPreview',
    component: AdDetail,
    props: (route: any) => {
      return {
        adFrontId: route.params.adFrontId,
        isPreview: true,
      };
    },
  },
  {
    path: '/estate-list',
    name: 'AdUserList',
    component: AdOfferList,
    meta: { requiresAuth: true },
    props: () => {
      return {
        mode: OfferListMode.userlist,
      };
    },
  },
  {
    path: '/developer-project/create',
    name: 'AdDeveloperProjectFormCreate',
    component: AdDeveloperProjectForm,
    meta: { requiresAuth: true, requiresEstateAgent: true },
  },
  {
    path: '/developer-project/detail/:adFrontId',
    name: 'AdDeveloperProjectFormDetail',
    meta: { requiresAuth: true, requiresEstateAgent: true },
    component: AdDeveloperProjectDetail,
    props: (route: any) => {
      return {
        adFrontId: route.params.adFrontId,
      };
    },
  },
  {
    path: '/developer-project/:adFrontId',
    name: 'AdDeveloperProjectFormEdit',
    meta: { requiresAuth: true, requiresEstateAgent: true },
    component: AdDeveloperProjectForm,
    props: (route: any) => {
      return {
        adFrontId: route.params.adFrontId,
      };
    },
  },
  {
    path: '/developer-project-list',
    name: 'AdDeveloperProjectList',
    component: AdOfferList,
    meta: { requiresAuth: true, requiresEstateAgent: true },
    props: () => {
      return {
        mode: OfferListMode.developerproject,
      };
    },
  },
  {
    path: '/agency-estate-list/',
    name: 'AdUserAgencyList',
    component: AdOfferList,
    meta: { requiresAuth: true, requiresEstateAgent: true },
    props: () => {
      return {
        mode: OfferListMode.myestateagency,
      };
    },
  },
  {
    path: '/agency/:urlName',
    name: 'AdAgencyList',
    component: EstateAgencyPublicProfile,
    props: (route: any) => {
      return {
        urlName: route.params.urlName,
      };
    },
  },
  {
    path: '/agent/:urlName',
    name: 'AdAgentList',
    component: EstateAgentPublicProfile,
    props: (route: any) => {
      return {
        urlName: route.params.urlName,
      };
    },
  },
  {
    path: '/favorite',
    name: 'AdUserFavorite',
    component: AdOfferList,
    meta: { requiresAuth: true },
    props: () => {
      return {
        mode: OfferListMode.favorite,
      };
    },
  },
  {
    path: '/history',
    name: 'AdHistory',
    component: AdOfferList,
    meta: { requiresAuth: true },
    props: () => {
      return {
        mode: OfferListMode.history,
      };
    },
  },
  {
    path: '/statistics',
    name: 'AdStatistics',
    component: AdStatistics,
    meta: { requiresAuth: true },
  },
  {
    path: '/filter-list',
    name: 'AdFilterList',
    component: AdFilterList,
    meta: { requiresAuth: true },
  },
  {
    path: '/compare',
    name: 'AdCompare',
    component: AdCompare,
  },
  {
    path: '/thank-you/:adFrontId',
    name: 'AdThankYou',
    component: AdThankYou,
    meta: {
      requiresAuth: true,
      showHeader: false,
    },
    props: (route: any) => {
      return {
        adFrontId: route.params.adFrontId,
      };
    },
  },
  {
    path: '/:q?/:q2?/:q3?',
    name: 'AdSearch',
    component: AdSearch,
    meta: {
      showFooter: false,
    },
    props: (route: any) => {
      return {
        q: route.params.q,
        q2: route.params.q2,
        q3: route.params.q3,
      };
    },
  },
];

export default adRoutes;
